const confirmExtendedKey =
  /Extended Key Usage[\s]+: 1\.3\.6\.1\.5\.5\.7\.3\.2 Проверка подлинности клиента/;
const certDevider = /[\d]+[-]{7}([\s\S]*?)(?=[\d]+[-]{7}|={3,})/gm;
const subjectParser = /Subject[\s]+: ([\s\S]*?)(?=Serial)/;
const keyIdParser = /SubjKeyID[\s]+: ([\s\S]*?)(?=Signature Algorithm)/;

/**
 * Transforms server responce into cert object array
 * @param {string} res
 * @returns {{subjKeyId : string, subject : string}[]}
 */
export function parseCerts(res) {
  return devideCerts(res)
    .filter((cert) => cert.search(confirmExtendedKey) !== -1)
    .map(parseCert);
}

/**
 * Parses responce from the server into strings of certs
 * @param {string} text text that comes from the responce
 * @returns {string[]}
 */

function devideCerts(text) {
  let m;
  const certs = [];
  while ((m = certDevider.exec(text)) !== null) certs.push(m[1]);
  return certs;
}
/**
 * Parses cert string into object
 * @param {string} cert
 * @returns {{subjKeyId : string, subject : string}}
 */
function parseCert(cert) {
  return {
    subjKeyId: keyIdParser.exec(cert)[1].replace("\n", ""),
    subject: subjectParser.exec(cert)[1].replace("\n", ""),
  };
}
